import dynamic from "next/dynamic";
import React, { useEffect, useRef } from "react";
const Navbar = dynamic(() => import("../components/Navbar"), {
  ssr: false,
});
import { useState } from "react";
import capabilitiesData from "../utils/capability.json";
import CarouselContainer from "../components/reusable/CarouselContainer";
import { CapabilityCard, CapabilityCard2 } from "../components/services/Capabilities2";
import useScreenSize from "../hooks/useScreenSize";
import IndustryPage from "../components/IndustryPage";
import FullScreenModal from "../components/reusable/FullScreenModal";
import { categoriesData } from "../utils/data";
import Footer from "../components/Footer";
import { motion } from "framer-motion";

const Capabilities = () => {
  const size = useScreenSize();
  const isSmall = size == "sm" || size == "md";
  const [selectedItem, setselectedItem] = useState("");
  const [currentBlog, setcurrentBlog] = useState({});
  const [modalConfig, setmodalConfig] = useState({
    open: false,
    children: <></>,
  });
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const uniqueCategories = [...new Set(capabilitiesData.map(item => item.category))];
    setCategories(uniqueCategories);

    if (size) {
      setTimeout(() => {
        const hash = window.location.hash;
        const id = hash?.substring(1);
        const element = document.getElementById(id);
        if (id != "Industry") {
          const scrollable = document.getElementById("scrollable");

          if (element) {
            const filteredCapability = capabilitiesData.filter(capability => capability.category == id);
            if (!isSmall) {
              setselectedItem(filteredCapability?.[0]?.title);
            }
            const rect = element.getBoundingClientRect();
            const scrollTopPos = rect.top + window.scrollY;
            const targetScrollTopPos = scrollTopPos - 200; // 200px above the element
            scrollable.scrollTop = targetScrollTopPos;
            // window.scrollTo({ top: targetScrollTopPos, behavior: "smooth" });
          } else {
            if (!isSmall) {
              setselectedItem(capabilitiesData?.[0]?.title);
            }
          }
        } else {
          if (element) {
            const filteredCapability = capabilitiesData.filter(capability => capability.category == id);
            if (!isSmall) {
              setselectedItem(filteredCapability?.[0]?.title);
            }
            const rect = element.getBoundingClientRect();
            const scrollTopPos = rect.top + window.scrollY;
            const targetScrollTopPos = scrollTopPos - 60;
            window.scrollTo({ top: targetScrollTopPos, behavior: "smooth" });
          }
        }
      }, 500);
    }
  }, [size]);

  useEffect(() => {
    const contentIdx = capabilitiesData.findIndex(item => item.title === selectedItem);
    if (contentIdx != -1) {
      let selected = capabilitiesData[contentIdx];
      setcurrentBlog({
        title: selected.title,
        subtitle: selected.desc || selected.paragraph,
        img: selected.image,
        category: selected.category,
        link: selected.link,
      });

      if (isSmall) {
        setmodalConfig({
          open: true,
          children: (
            <CapabilityCard
              title={selected.title}
              subtitle={selected.desc}
              hideTitle
              knowMoreLink={selected.link}
              imgStyle=" rounded-[100%] h-[300px] w-[300px]"
            />
          ),
        });
      }
    }
  }, [selectedItem, isSmall]);

  const sectionRef = useRef(null);

  const scrollToSection = () => {
    if (sectionRef.current) {
      sectionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <div className="bg-white">
      <Navbar />

      {/* capability */}
      <div className="bg-[#1B6B93]">
        <div className="mx-auto max-w-[1600px] w-[90%] md:w-[85%] bg-[#1B6B93] pt-[80px] pb-[30px]">
          <h1 className="w-fit text-4xl font-bold pb-4 text-white">Our Capabilities</h1>
          <div className="w-[200px] h-[1px] bg-white mb-4"></div>
          <div className="flex justify-between mt-2  ">
            <div id="scrollable" className="w-[100%] md:w-[40%] max-h-[70vh] overflow-y-auto no-scrollbar pl-4">
              {categories.map(category => {
                const filteredCapability = capabilitiesData.filter(capability => capability.category == category);
                let categoryDesc = categoriesData?.filter(categoryItem => categoryItem.title === category);
                categoryDesc = categoryDesc?.[0]?.["desc"];

                return (
                  <div
                    key={category}
                    id={category}
                    className={` text-black cursor-pointer mb-20 ${category == categories?.[categories.length - 1] ? "mb-[50vh]" : ""}`}
                  >
                    <div className="mb-[20px] md:mb-5">
                      <h3 className=" text-white text-4xl font-bold mb-2 ">{category}</h3>
                      <p className="text-white/50 text-xl">{categoryDesc}</p>
                    </div>
                    {isSmall ? (
                      <CarouselContainer>
                        {filteredCapability.map(capability => {
                          return (
                            <div key={capability.key} className=" mb-6 py-4 px-4 w-[90%] mx-auto ">
                              <CapabilityCard2
                                key={capability.title}
                                title={capability.title}
                                img={capability.image}
                                onHoverStart={() => setselectedItem(capability.title)}
                                activeItem={selectedItem}
                                isSmall={isSmall}
                                imgStyle="rounded-[100%] !h-[200px] !w-[200px]"
                              />
                            </div>
                          );
                        })}
                      </CarouselContainer>
                    ) : (
                      filteredCapability.map(capability => (
                        <CapabilityCard2
                          key={capability.title}
                          title={capability.title}
                          onHoverStart={() => setselectedItem(capability.title)}
                          activeItem={selectedItem}
                          isSmall={isSmall}
                          hideSubtitle
                          fadeTxtColor="#ababab"
                          styleClass="mb-1 !pl-0"
                        />
                      ))
                    )}
                  </div>
                );
              })}
            </div>
            <div className="hidden md:block md:w-[50%] whitespace-pre-line ">
              <div>
                {selectedItem && currentBlog?.title ? (
                  <CapabilityCard
                    subtitle={currentBlog.subtitle}
                    img={currentBlog.img}
                    hideTitle
                    knowMoreLink={currentBlog.link}
                    imgStyle=" rounded-[100%] !h-[260px] !w-[260px]"
                  />
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="pb-[30px] mx-auto w-full flex flex-col items-center justify-center">
          <div className="font-semibold text-2xl mb-4 text-white">Industries We Serve</div>

          <motion.div onClick={scrollToSection} className="box" variants={containerVariants} initial="initial" animate="animate">
            <svg className="rotate-90 cursor-pointer " width="40" height="40" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
              <circle cx="50" cy="50" r="40" stroke="white" strokeWidth="2" fill="transparent" />
              <path d="M 50 30 L 70 50 L 50 70" stroke="white" strokeWidth="2" fill="transparent" />
            </svg>
          </motion.div>
        </div>
      </div>

      <FullScreenModal
        isOpen={modalConfig.open}
        onClose={() => {
          setmodalConfig(() => ({ open: false, children: <></> }));
          setselectedItem("");
        }}
        styleClass="[&>div]:!bg-[#1B6B93]"
      >
        {modalConfig.children}
      </FullScreenModal>

      {/* industry */}
      <div ref={sectionRef}>
        <IndustryPage />
      </div>

      <Footer />
    </div>
  );
};

export default Capabilities;

const containerVariants = {
  initial: { y: 0 },
  animate: {
    y: [-5, 0, -5], // Sequence of y-axis values for animation
    transition: {
      y: {
        duration: 1, // Duration for each step of the animation
        repeat: Infinity, // Repeat the animation indefinitely
        ease: "easeInOut", // Easing function
      },
    },
  },
};